import styled from 'styled-components';

export const Container = styled.section`
  margin: 5px 25px;
  padding-bottom: 35px;
  border-top: 1px solid black;
`;

export const StartupsList = styled.div`
  display: grid;
  gap: 25px;

  @media (max-width: 1000px) {
    .bg-ContentImage {
      display: none;
    }
  }

  @media (max-width: 425px) {
    article {
      grid-template-columns: auto;
    }

    div {
      border-radius: 0;
    }
  }
`;
